import { startImathbookSsoApi } from '@/api/user/userApi';
import { isVisitor } from '@/utils/auth';
import { error as showError } from '@/utils/toast';

const imathbookOrigin = (import.meta.env.VITE_IMATHBOOK_ORIGIN || 'https://imathbook.com').replace(/\/$/, '');
const imathbookTarget = `${imathbookOrigin}/bookshelf`;
const imathbookSignInUrl = `${imathbookOrigin}/sign-in?next=%2Fbookshelf`;

export async function openImathbook() {
  if (isVisitor()) {
    window.location.assign(imathbookSignInUrl);
    return;
  }

  try {
    const { redirectUrl } = await startImathbookSsoApi(imathbookTarget);
    if (!redirectUrl)
      throw new Error('SSO 跳转地址为空');
    window.location.assign(redirectUrl);
  }
  catch (error: any) {
    showError(error?.message || '免登录跳转失败，请在 iMathBook 登录');
    window.location.assign(imathbookSignInUrl);
  }
}
